import { MenuDataLocale } from "../../menudata/types/MenuDataLocale";

export const LEGACY_SURCHARGE_MESSAGE_TEXT =
    "Venue and/or payment surcharges may apply, please review all charges before submitting your order.";

export const GUEST_PLATFORM_FEE_SURCHARGE_MESSAGE_TEXT =
    "Platform and service fees may apply. Please review all charges before submitting your order.";

// Keyed on currency, matching the fee label this sentence sits above: a venue can carry AUD without
// an en-AU locale, and en-NZ must keep the legacy sentence.
export const getSurchargeMessageText = (
    menuDataLocale: MenuDataLocale,
    guestPlatformFeeEnabled?: boolean | null
) =>
    menuDataLocale.currency?.toUpperCase() === "AUD" && guestPlatformFeeEnabled
        ? GUEST_PLATFORM_FEE_SURCHARGE_MESSAGE_TEXT
        : LEGACY_SURCHARGE_MESSAGE_TEXT;
